export default __webpack_public_path__ + "static/media/ico-google-white.574615bb.svg";